import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import Loading from '@/components/widgets/Loading.vue'
import SortedTablePlugin from "vue-sorted-table"
import MenuList from './widget-menu'
import Paginate from "@/components/widgets/pagination.vue";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    Loading,
    MenuList,
    DatePicker,
    Paginate
  },
  data: function() {
    return {
      branches: [], // ต้องประกาศไว้ให้ reactive
      role: "",
      branch: "",
      isOrderClerk: false,
      keyword_document_no: "",
      keyword_status: null,
      keyword_branch: null,
      loading: false, 
      busy: false,
      status: null,      
      perPage: 8,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      requestDocumentStatus:[
        { text: "รอส่วนกลางพิจารณา", value: 1 },
        { text: "สร้างใบจัดม้วนแล้ว", value: 2 },
        { text: "ยกเลิกคำขอ", value: 3 },
        { text: "ปฏิเสธคำขอ", value: 4 },
      ],
      fields: [
        { 
          key: 'document_no', 
          label: 'เลขที่เอกสาร', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-black td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'date', 
          label: 'รับวันที่',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-500 td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'branch_id', 
          label: 'สาขา',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-500 td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'note', 
          label: 'หมายเหตุ', 
          sortable: true, 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2 ellipsis'
        },
        { 
          key: 'creator.name', 
          label: 'ผู้สร้าง', 
          sortable: true, 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2 ellipsis'
        },
        { 
          key: 'status', 
          label: 'สถานะ', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-500 td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'action', 
          label: '#', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-500 td-top text-xs-1/2'
        }
      ],
      items: [],
      totalItem: 0,
      apiStatus: 'ไม่พบข้อมูล'
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    async getRole(){
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res.data.role
      this.branch = res.data.branch_id
      // เสมียนสาขาที่เปิดไว้ (ตอนนี้ระยอง) สร้าง/ดูใบคำขอได้ — ตรงกับ App\Support\BranchClerk ฝั่ง backend
      this.isOrderClerk = this.role === 'Customer assistant' && ['RY'].includes((res.data.detail && res.data.detail.shortname) || '')
    },
    onMenuApproveOpenModal(event) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
          '<div class="d-flex flex-column">'+
          '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
          '<span class="text-base text-left text-gray-500">ท่านต้องการยืนยันการ `อนุมัติ` ใช่หรือไม่</span>'+
          '</div>'+
        '</div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            closeButton: 'text-3xl swal2-custom-close',
            actions: 'justify-content-end',
            contant: 'd-flex flex-row justify-content-around px-2',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
          },
          cancelButtonColor: '#dc4a38',
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          showCloseButton: true,
      }).then(async confirm => {
        if(confirm.value){
          try {
            this.loading = true
            const result = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/document/request/markAsDone/${event.id}`)

            this.loading = false
            setTimeout(() => {
              if(result.status === 200) window.location.reload()
            }, 500)
          } catch (error) {
            this.loading = false
            this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          }
        }
      })
    },
    onMenuRejectOpenModal(event) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
          '<div class="d-flex flex-column">'+
          '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
          '<span class="text-base text-left text-gray-500">ท่านต้องการยืนยันการ `ปฏิเสธ` ใช่หรือไม่</span>'+
          '</div>'+
        '</div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            closeButton: 'text-3xl swal2-custom-close',
            actions: 'justify-content-end',
            contant: 'd-flex flex-row justify-content-around px-2',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
          },
          cancelButtonColor: '#dc4a38',
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          showCloseButton: true,
      }).then(async confirm => {
        if(confirm.value){
          try {
            this.loading = true
            const result = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/document/request/markAsReject/${event.id}`)

            this.loading = false
            setTimeout(() => {
              if(result.status === 200) window.location.reload()
            }, 500)
          } catch (error) {
            this.loading = false
            this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          }
        }
      })
    },
    onMenuCancelOpenModal(event) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
          '<div class="d-flex flex-column">'+
          '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
          '<span class="text-base text-left text-gray-500">ท่านต้องการยืนยันการ `ยกเลิก` ใช่หรือไม่</span>'+
          '</div>'+
        '</div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            closeButton: 'text-3xl swal2-custom-close',
            actions: 'justify-content-end',
            contant: 'd-flex flex-row justify-content-around px-2',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
          },
          cancelButtonColor: '#dc4a38',
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          showCloseButton: true,
      }).then(async confirm => {
        if(confirm.value){
          try {
            this.loading = true
            const result = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/document/request/markAsCancel/${event.id}`)

            this.loading = false
            setTimeout(() => {
              if(result.status === 200) window.location.reload()
            }, 500)
          } catch (error) {
            this.loading = false
            this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          }
        }
      })
    },
    oncreate() {
      this.$router.push('/request/add')
    },
    async onInitData(currentPage) {
      this.currentPage = currentPage
      this.busy = true
      // this.items = []
      this.apiStatus = 'กำลังค้นหาข้อมูล..'
      try {
        const page = currentPage ? currentPage : 1
        const param = {
          page: page,
          keyword_document_no: this.keyword_document_no,
          keyword_status: this.keyword_status,
          keyword_branch: this.keyword_branch ? this.keyword_branch : '',
        }
        const result = await this.$store.dispatch('Documents/getAllRequestDocument', param, { root: true })
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'

        if (result) {
          this.currentData = result.data;
          this.items = result.data.data
          this.totalItem = result.data.total
        } else {
          this.items = []
          this.totalItem = 0
        }        
        
      } catch (error) {
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        this.apiStatus = 'ไม่พบข้อมูล'
        this.busy = false
        return []
      }
    },
    async getBranches() {
      const result = await this.$axios.get(this.$host + "/api/v1/branches", {
        headers: {
        },
      })
      this.branches = result.data
    },
  },
  mounted() {
    this.getBranches()
    this.onInitData(this.currentPage)
    this.getRole()
  }
}
